<template>
  <article class="flex items-end justify-between rounded-lg border border-gray-100 bg-gray-100 p-4 sm:p-6">
    <div class="flex items-center gap-4">
            <span class="hidden rounded-full bg-gray-100 p-2 text-gray-600 sm:block">
              <svg
                class="h-6 w-6"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
          </span>
      <div>
        <p class="text-sm text-gray-500">{{ label }}</p>
        <p class="text-lg font-medium text-gray-900 sm:text-2xl">{{ value }}</p>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "StatCard.vue",
  props: ["label", "value"],
};
</script>
<style scoped>

</style>
